import {Button, Stack, Typography,} from "@mui/material";
import React from "react";
import LayoutDialog from "@/components/layout/layout-dialog";


export default function AreYouSureDialog({
                                             message,
                                             onClose,
                                             onConfirm,
                                             open,
                                             title,
                                         }: {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
    title: string;
    message: string;
}) {

    return (
        <LayoutDialog
            maxWidth = "xs"
            title = {title}
            open = {open}
            handleClose = {onClose}
            dialogActions = {
                <Stack spacing = {2} direction = 'row' >
                    <Button
                        variant = "outlined"
                        onClick = {() => {
                            onClose();
                        }}
                        fullWidth
                    >
                        خیر
                    </Button >

                    <Button
                        fullWidth
                        onClick = {() => {
                            onClose();
                            onConfirm();
                        }}
                        color = {!(title.includes("تایید")) ? "error" : "success"}
                        variant = "contained"
                    >
                        بله
                    </Button >

                </Stack >
            }
        >
            <Typography component="p" sx={{fontSize: 16}}>
            {message}
            </Typography>
        </LayoutDialog >
    );
}
